import * as React from "react";
import * as d3 from "./assets/d3";
import { select } from "d3-selection";
import "./Yaxis.scss";
import { MarginContext, OPEN_RIGHT_MARGIN, CLOSED_RIGHT_MARGIN, } from "./Containers/MarginContextContainer";
var yAxis;
(function (yAxis) {
    yAxis["y1"] = "y1";
    yAxis["y2"] = "y2";
})(yAxis || (yAxis = {}));
export default class Y2axis extends React.PureComponent {
    constructor(props) {
        super(props);
        const { scale, tickFormat, height, labelHeight } = this.props;
        this.axisTitle = React.createRef();
        const axis = d3
            .axisRight(scale)
            .tickFormat(tickFormat)
            .ticks(Math.floor(height / (4 * labelHeight)));
        this.extraSpaceForLabel = 14;
        this.axisTitleToLabelsMargin = 10;
        this.state = {
            axis,
        };
    }
    updateAxisColor() {
        const { color } = this.props;
        const axisColor = color ? color : "black";
        select(this.arc)
            .call(this.state.axis)
            .selectAll("line")
            .attr("stroke", axisColor);
        select(this.arc)
            .call(this.state.axis)
            .selectAll("path")
            .attr("stroke", axisColor);
    }
    componentDidMount() {
        this.updateAxisColor();
        this.checkIfMarginUpdates();
    }
    componentDidUpdate() {
        const { scale, tickFormat, height, labelHeight } = this.props;
        select(this.arc).call(this.state.axis
            .scale(scale)
            .tickFormat(tickFormat)
            .ticks(Math.floor(height / (4 * labelHeight))));
        this.updateAxisColor();
        this.checkIfMarginUpdates();
    }
    componentWillUnmount() {
        const { setRightMargin, isLegendOpen } = this.context;
        if (isLegendOpen) {
            setRightMargin(OPEN_RIGHT_MARGIN);
        }
        else {
            setRightMargin(CLOSED_RIGHT_MARGIN);
        }
    }
    getMaxLabelWidthFromAxis(axis) {
        if (!this.arc) {
            return 30;
        }
        const textLabels = axis === yAxis.y1
            ? document.querySelectorAll(".focus-grafos-y-axis text")
            : this.arc.querySelectorAll("text");
        const labelsWidth = [...textLabels].map((label) => typeof label.getBBox === "function" ? label.getBBox().width : 50);
        const maxLabelWidth = labelsWidth.length > 0 ? Math.max(...labelsWidth) : 0;
        return maxLabelWidth;
    }
    checkIfMarginUpdates() {
        const maxY2LabelWidth = this.getMaxLabelWidthFromAxis(yAxis.y2);
        const axisTitleHeight = typeof this.axisTitle.current.getBBox === "function"
            ? this.axisTitle.current.getBBox().height
            : 10;
        const { setRightMargin, isLegendOpen } = this.context;
        const rightMarginDif = axisTitleHeight +
            this.axisTitleToLabelsMargin +
            this.extraSpaceForLabel +
            maxY2LabelWidth;
        const newMargin = isLegendOpen
            ? OPEN_RIGHT_MARGIN + rightMarginDif
            : CLOSED_RIGHT_MARGIN + rightMarginDif;
        if (this.props.margins.right !== newMargin) {
            setRightMargin(newMargin);
        }
    }
    render() {
        const { margins, title, height, width } = this.props;
        const t = `translate(${width + margins.left},0)`;
        const axisTitlePosition = width +
            margins.left +
            this.getMaxLabelWidthFromAxis(yAxis.y2) +
            this.axisTitleToLabelsMargin +
            this.extraSpaceForLabel +
            4;
        return (React.createElement(React.Fragment, null,
            React.createElement("text", { ref: this.axisTitle, transform: `translate(${axisTitlePosition} ,${height / 2 + margins.top}) rotate(-90)`, className: "focus-grafos-Y-title" }, title),
            React.createElement("g", { className: "focus-grafos-y2-axis", "data-testid": "vertical-axis", transform: t, ref: (ref) => {
                    this.arc = ref;
                } })));
    }
}
Y2axis.contextType = MarginContext;
//# sourceMappingURL=Y2axis.js.map